// extracted by mini-css-extract-plugin
export default {"root":"CsvTableDetails_root__0e84T","closeIcon":"CsvTableDetails_closeIcon__e58eZ","table":"CsvTableDetails_table__y5C96"};